import React from 'react';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import { getOptionPureText } from '@gp/utils/select';
import { GET_TEXT_WITH_HIGHLIGHT_OPTION } from '@gp/constants/const';

import type { SelectOptionWithGroup } from 'tea-component';

export const defaultOptionTextRenderer: IGPSelectOptionTextRenderer = (option, props) => {
  const { highlightable = false, highlightText = '', splitter = false } = props || {};
  const { icon } = option || {};
  const pureText = getOptionPureText(option);
  const isMatchedTextHighlight = highlightable && !!highlightText;

  return (
    <span title={pureText}>
      {!!icon && (
        <span className="img-container">
          <img src={icon} alt="" />
        </span>
      )}
      <span>
        {!isMatchedTextHighlight
          ? pureText
          : getTextWithHighlight(pureText, highlightText, GET_TEXT_WITH_HIGHLIGHT_OPTION)}
      </span>
      {/* 分割的, */}
      {splitter && ', '}
    </span>
  );
};

export const renderButton = (
  button?: React.ReactNode | ((selectedOption: SelectOptionWithGroup) => React.ReactNode),
  props?: {
    options?: IGPSelectOptionWithGroup[];
    value?: string;
    showLabel?: boolean;
    label?: string;
    placeholder?: string;
    optionTextRenderer?: IGPSelectOptionTextRenderer;
  },
) => {
  if (button) return button;
  const { options, value, showLabel = true, label, placeholder, optionTextRenderer } = props || {};
  if (!value) {
    if (showLabel && label) {
      return (
        <>
          <span className="select-button-text">{label}</span>
          <span className="dbg-common-select-placeholder">{placeholder}</span>
        </>
      );
    }
    return <span className="dbg-common-select-placeholder">{placeholder}</span>;
  }
  const option = options?.find((option) => option?.value === value);
  const text = optionTextRenderer?.(option) ?? option?.text;
  if (!showLabel || !label) return text;
  return (
    <>
      <span className="select-button-text">{label}</span>
      <span className="select-button-value">{text}</span>
    </>
  );
};
